export default "/kiban/_next/static/images/btn_spec-cf7a0663bd440c252525182ce33405c9.png";